// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-legend {
  margin-top: 2rem;
  padding: 1.25rem;
  background-color: var(--bs-body-bg, #fff);
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
}

.calendar-legend h2 {
  margin: 0 0 1rem;
  font-size: 1.5rem;
}

.category-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.5rem;
  list-style: none;
  padding: 0;
  margin: 0;
}

.category-list li {
  display: flex;
  align-items: center;
}

.category-color-box {
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CalendarPage/Panel/SchedulePanel.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".calendar-legend {\n  margin-top: 2rem;\n  padding: 1.25rem;\n  background-color: var(--bs-body-bg, #fff);\n  border: 1px solid #dee2e6;\n  border-radius: 0.5rem;\n}\n\n.calendar-legend h2 {\n  margin: 0 0 1rem;\n  font-size: 1.5rem;\n}\n\n.category-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 1.5rem;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.category-list li {\n  display: flex;\n  align-items: center;\n}\n\n.category-color-box {\n  width: 20px;\n  height: 20px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
